class ZipSearch {
  constructor(el) {
    this.el = el;
    if (document.querySelectorAll("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const buttons = document.querySelectorAll("." + this.el);

    buttons.forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        e.preventDefault();

        const root = btn.closest("form") || btn.closest(".p-entry") || document;
        const zipName = btn.getAttribute("data-zip-name") || "your-zip";
        const addressName = btn.getAttribute("data-address-name") || "your-address";
        const zipInput = root.querySelector(`[name="${zipName}"]`);
        const addressInput = root.querySelector(`[name="${addressName}"]`);

        if (!zipInput || !addressInput) {
          return;
        }

        const zipcode = String(zipInput.value || "").replace(/[^0-9]/g, "");
        if (zipcode.length !== 7) {
          window.alert("郵便番号はハイフンなしの7桁で入力してください。");
          return;
        }

        btn.disabled = true;

        try {
          const res = await fetch(
            `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`
          );
          const data = await res.json();

          if (!data || data.status !== 200 || !data.results || !data.results[0]) {
            window.alert("住所が見つかりませんでした。郵便番号をご確認ください。");
            return;
          }

          const result = data.results[0];
          addressInput.value = `${result.address1 || ""}${result.address2 || ""}${result.address3 || ""}`;
          addressInput.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (err) {
          window.alert("住所の取得に失敗しました。しばらくしてから再度お試しください。");
        } finally {
          btn.disabled = false;
        }
      });
    });
  }
}
